import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {cancelProcessBatchSchema} from '../../../../schema/laundryBatch'
import {getMasterService} from '../../../../../central/services'
import {TypeClothe} from '../../../../model'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {ShowSnackBar} from '../../../../../../util/functions'
import {cancelProcessBatch} from '../../../../services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {useKTable} from '../../../../../../contexts/KTableProvider'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

const ModalCancel: FC<Props> = ({show, setShow}) => {
  const [typeObservations, setTypeObservations] = useState<TypeClothe[] | any>([])
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {clearSelected, setUpdateTable} = useKTable()
  const [loading, setLoading] = useState<boolean>(false)

  const methods = useForm<TypeClothe>({
    resolver: yupResolver(cancelProcessBatchSchema),
  })
  const {
    control,
    setValue,
    handleSubmit,
    formState: {errors},
  } = methods

  const getTypeObservationsList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'MOTIVOCANCELACIONORDENLOTE',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeObservations(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getTypeObservationsList()
  }, [])

  const handleClose = () => {
    setShow(false)
    setValue('estado', '')
    setValue('tipoObservacion', '')
    clearSelected()
  }

  const onSubmit = async (data: any) => {
    try {
      setLoading(true)
      const {data: res} = await cancelProcessBatch(
        currentTabItem.detailRow.id,
        data.motivo,
        currentTabItem.typeWash,
      )
      if (!res.error) {
        ShowSnackBar('Se canceló con exito')
        setUpdateTable(true)
        changeCurrentTabItem({
          ...currentTabItem,
          typeAdmin: '',
          typeProcess: '',
          isStartLaundry: false,
          isFinishOut: false,
          isFinishLaundry: false,
          isCancel: false,
          detailRow: null,
        })
        setLoading(false)
        handleClose()
      } else {
        setLoading(false)
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {
      setLoading(false)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Cancelar Lavado</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row mb-4'>
                <div className='mb-2 col-12'>
                  <label>Motivo</label>
                  <Select control={control} name='motivo' data={typeObservations} errors={errors} />
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalCancel}
